export function makeLoadingState<T>(data: T) {
  return {
    isLoading: true as const,
    isError: false as const,
    data: data,
  };
}
